const baseCalendarTileStyles = { position: 'relative' };

export const CalendarTileStyles = {
  variants: {
    home: {
      ...baseCalendarTileStyles,
      textAlign: 'left',
      maxWidth: { base: '155px', sm: '162px', md: '174px', xl: '191px' },
    },
    browse: {
      ...baseCalendarTileStyles,
      textAlign: 'center',
      lineHeight: 'initial',
      minWidth: ['155px', '162px', '33%'],
      width: { base: '50%', md: 1 / 3 },
      height: { base: '320px', md: '444px' },
    },
    release: {
      ...baseCalendarTileStyles,
      textAlign: 'center',
      lineHeight: 'initial',
      minWidth: ['155px', '162px', '33%'],
      width: '100%',
      height: { base: '320px', md: '444px' },
    },
  },
};

const baseCalendarTileInnerStyles = {
  border: '1px solid',
  borderColor: 'neutral.200',
};

export const CalendarTileInnerStyles = {
  variants: {
    home: {
      ...baseCalendarTileInnerStyles,
      padding: '10px 8px',
      margin: 0,
    },
    browse: {
      ...baseCalendarTileInnerStyles,
      padding: 4,
      mt: 6,
      mr: 4,
    },
    release: {
      ...baseCalendarTileInnerStyles,
      margin: 0,
    },
  },
};

const baseCalendarTileNameStyles = {
  height: 12,
  lineHeight: 4,
  mr: 0,
  overflow: 'hidden',
  pt: [4, 0, 0],
};

export const CalendarTileNameStyles = {
  variants: {
    home: {
      ...baseCalendarTileNameStyles,
      mt: [2, 3, null],
    },
    browse: {
      ...baseCalendarTileNameStyles,
      textAlign: { base: 'center', sm: 'left' },
      overflow: 'hidden',
      pt: 0,
      mb: 1,
    },
  },
};
